// Compte à rebours vers la vraie fin de l'offre (settings.snk_period_end, heure de Paris).
// Règle DGCCRF : il ne se relance jamais. Une fois l'échéance passée, il disparaît.
if (!customElements.get('snk-countdown')) {
  customElements.define(
    'snk-countdown',
    class SnkCountdown extends HTMLElement {
      connectedCallback() {
        this.end = SnkCountdown.parisTime(this.dataset.end);
        if (!this.end) return;
        this.tick();
        this.timer = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this.timer);
      }

      // « AAAA-MM-JJ HH:MM » lu comme une heure de Paris, changement d'heure compris.
      static parisTime(value) {
        const match = /^(\d{4})-(\d{2})-(\d{2})[ T](\d{2}):(\d{2})$/.exec((value || '').trim());
        if (!match) return null;
        const [, y, mo, d, h, mi] = match.map(Number);
        const wall = Date.UTC(y, mo - 1, d, h, mi);
        const offset = (instant) => {
          const parts = Object.fromEntries(
            new Intl.DateTimeFormat('en-US', {
              timeZone: 'Europe/Paris',
              hourCycle: 'h23',
              year: 'numeric',
              month: 'numeric',
              day: 'numeric',
              hour: 'numeric',
              minute: 'numeric',
            })
              .formatToParts(instant)
              .map((p) => [p.type, Number(p.value)])
          );
          return Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute) - instant;
        };
        const guess = wall - offset(wall);
        return guess - (offset(guess) - offset(wall));
      }

      tick() {
        const remaining = Math.floor((this.end - Date.now()) / 1000);
        if (remaining <= 0) {
          clearInterval(this.timer);
          this.hidden = true;
          return;
        }
        const pad = (n) => String(n).padStart(2, '0');
        const days = Math.floor(remaining / 86400);
        const units = [
          [pad(Math.floor((remaining % 86400) / 3600)), this.dataset.hours],
          [pad(Math.floor((remaining % 3600) / 60)), this.dataset.minutes],
          [pad(remaining % 60), this.dataset.seconds],
        ];
        if (days) units.unshift([days, this.dataset.days]);

        const label = document.createElement('span');
        label.className = 'snk-an__cd-label';
        label.textContent = this.dataset.label;
        const boxes = units.map(([value, unit]) => {
          const box = document.createElement('b');
          box.className = 'snk-an__cd-unit';
          const small = document.createElement('small');
          small.textContent = unit;
          box.append(String(value), small);
          return box;
        });
        this.replaceChildren(label, ...boxes);
        this.hidden = false;
      }
    }
  );
}
